import React, { useState, useEffect } from 'react';
import Layout from './components/Layout';
import AppRoutes from './AppRoutes';
import RouteScrollToTop from './components/RouteScrollToTop';
import LoadingScreen from './components/LoadingScreen';
import { AudioPlayerProvider } from './context/AudioPlayerContext';

const App = () => {
  const [isInitialLoad, setIsInitialLoad] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsInitialLoad(false);
    }, 300);

    return () => clearTimeout(timer);
  }, []);

  return (
    <AudioPlayerProvider>
      <LoadingScreen isLoading={isInitialLoad} />
      <Layout>
        <RouteScrollToTop />
        <AppRoutes />
      </Layout>
    </AudioPlayerProvider>
  );
};

export default App;
